import {
  Box,
  Typography,
  Container,
  Card,
  Button,
  Avatar,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import StrategyForm from "../components/StrategyForm";

const AddStrategyPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Add Strategy | Vantage Alpha</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[50] : '#ebebeb',
          background: theme.palette.mode === "dark" ? theme.palette.grey[50] : '#ebebeb',
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate("/strategies")}
              sx={{
                textTransform: "none",
                color: theme.palette.text.secondary,
                mb: 2,
              }}
            >
              Back to Strategies
            </Button>
          </Box>

          <Container maxWidth={'sm'}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
              <Avatar sx={{ bgcolor: "primary.main", width: 48, height: 48 }}>
                <TrendingUpIcon />
              </Avatar>
              <Box>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 600, color: theme.palette.text.primary }}
                >
                  Add Strategy
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ color: theme.palette.text.secondary }}
                >
                  Create a new trading strategy with custom parameters
                </Typography>
              </Box>
            </Box>
            <Card
              sx={{
                borderRadius: 2,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                border: `1px solid ${theme.palette.divider}`,
                p: 3,
              }}
            >
              <StrategyForm onSuccess={() => navigate("/strategies")} />
            </Card>
          </Container>
        </Container>
      </Box>
    </>
  );
};

export default AddStrategyPage;
